import Render from '@Views/components/layout/central.html'
import { Vue, Component } from 'vue-property-decorator'

@Render
@Component({})
export class Central extends Vue {}
